import { useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { localePath, stripLangPrefix } from './config';

/**
 * 現在の言語を保ったままページ遷移するためのフック。
 * これを使わずに navigate('/about') すると、英語ページから日本語ページへ
 * 飛んでしまうため、内部リンクは必ずこれを経由させる。
 */
export function useLocalizedNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const { lang, rest } = useMemo(
    () => stripLangPrefix(location.pathname),
    [location.pathname]
  );

  /** 言語プレフィックスを付けたパスを返す（リンクのhref用）。 */
  const to = useCallback((path) => localePath(path, lang), [lang]);

  /** 現在の言語のまま遷移する。 */
  const navigateTo = useCallback(
    (path, options) => navigate(localePath(path, lang), options),
    [navigate, lang]
  );

  /** 同じページのまま言語だけを切り替える。 */
  const switchLang = useCallback(
    (nextLang) =>
      navigate(localePath(rest, nextLang) + location.search + location.hash),
    [navigate, rest, location.search, location.hash]
  );

  return { lang, pathWithoutLang: rest, to, navigate: navigateTo, switchLang };
}

export default useLocalizedNav;
